import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaHome, FaUsers, FaMoneyBillWave, FaPaperPlane, FaBell, FaIdCard, FaGlobe, FaCheckCircle } from 'react-icons/fa';
import './OnboardingModal.css';

const OnboardingModal = ({ show, onHide }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      title: 'Karibu Harusi Online!',
      description: 'Asante kwa kujiunga. Mfumo huu utakusaidia kusimamia shughuli yako kwa urahisi na ufanisi. Hebu tupitie jinsi unavyofanya kazi.',
      icon: <FaHome className="onboarding-icon" />
    },

    {
      title: 'Kusimamia Wageni',
      // description: 'Sehemu ya "Wageni" inakuruhusu kuongeza majina ya waalikwa, kufuatilia ahadi zao, na kujua ni nani tayari ameshatoa mchango.',
      description: 'Ongeza Wageni wako kwa kuingiza taarifa zao (majina na namba zao za simu) kwenye mfumo kwa ku-upload Excel au Contacts Kutoka kwenye simu yako.',
      icon: <FaUsers className="onboarding-icon" />
    },

    {
      title: 'Tuma Taarifa',
      description: 'Julisha wageni wako kuhusu shughuli yako. Acha wageni wako waahidi wenyewe Online kupitia Tovuti yako maalumu.',
      icon: <FaPaperPlane className="onboarding-icon" />
    },

    {
      title: 'Kumbushia Michango',
      description: 'Wakumbushe Wadau wako Kuhusu michango ambayo bado kwa kutuma mesage za jumla kirahisi sana yaani kwa "Click" moja tu ',
      icon: <FaBell className="onboarding-icon" />
    },
    {
      title: 'Kadi za Kidigitali (E-Cards)',
      description: 'Tengeneza kadi za Kidigitali na samabaza kwa wageni wako kwa hatua rahisi, tuma mialiko kwa SMS au WhatsApp.',
      icon: <FaIdCard className="onboarding-icon" />
    },
    {
      title: 'Taarifa za Kifedha',
      description: 'Panga bajeti yako na uweke rekodi za kila mchango unaoingia na matumizi yanayofanyika, Ili kupata Ripoti na Takwimu kwa pdf na Excel ili kuweza kusambaza kirahisi kwa Wanakamati  .',
      icon: <FaMoneyBillWave className="onboarding-icon" />
    },
    {
      title: 'Tovuti Ya BURE',
      description: 'Tovuti Binafsi ya Shughuli Yako, Ambapo Matukio Yote ya Shughuli Yako kama (Picha,Tarehe, Location na Mengineyo）Yataonekana.',
      icon: <FaGlobe className="onboarding-icon" />
    },

    {
      title: 'Upo Tayari Kuanza!',
      description: 'Sasa uko tayari kusimamia shughuli yako.Kila la kheri!',
      icon: <FaCheckCircle className="onboarding-icon text-success" />
    }
  ];

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onHide();
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSkip = () => {
    onHide();
  };

  const currentStepData = steps[currentStep];

  return (
    <Modal
      show={show}
      onHide={handleSkip}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="onboarding-modal-content"
    >
      <Modal.Header closeButton className="onboarding-header">
        <Modal.Title className="w-100 text-center"></Modal.Title>
      </Modal.Header>

      <Modal.Body className="onboarding-body">
        <div className="onboarding-icon-wrapper">
          {currentStepData.icon}
        </div>

        <h3 className="onboarding-title">{currentStepData.title}</h3>
        <p className="onboarding-desc">{currentStepData.description}</p>

        <div className="onboarding-indicators">
          {steps.map((_, index) => (
            <div
              key={index}
              className={`onboarding-dot ${index === currentStep ? 'active' : ''}`}
            />
          ))}
        </div>
      </Modal.Body>

      <Modal.Footer className="onboarding-footer">
        <button className="skip-btn" onClick={handleSkip}>
          {currentStep === steps.length - 1 ? '' : 'Skip Tour'}
        </button>

        <div className="d-flex gap-3">
          {currentStep > 0 && (
            <button className="onboarding-btn btn-prev" onClick={handlePrev}>
              Previous
            </button>
          )}
          <button className="onboarding-btn btn-next" onClick={handleNext}>
            {currentStep === steps.length - 1 ? 'Anza Kutumia' : 'Next'}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default OnboardingModal;
